import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import EventsRepository from '../../../repositories/EventsRepository';
import EventsDataRepository from '../../../../data/repositories/EventsDataRepository';

export default function* execute(action: any): any {
  try {
    const { eventId } = action;
    yield put({ type: Types.SET_EVENT_INSCRIPTION_REQUEST });
    const eventsRepository: EventsRepository = new EventsDataRepository();
    const eventResponse = yield call(
      eventsRepository.setEventInscription,
      eventId
    );
    if (!eventResponse) {
      yield put({
        type: Types.SET_EVENT_INSCRIPTION_FAILURE,
        error: true
      });
      return;
    }
    yield put({
      type: Types.SET_EVENT_INSCRIPTION_SUCCESS,
      data: eventResponse
      /// data: { status: 'OK', data: 'Inscripción registrada con éxito',message: 'OK'} // OK
      /// data: { status: 'Error', data: 'Algo', message: 'No vacancies' } // eventResponse
      /// data: { status: 'Error', data: 'Algo', message: 'ZOOMACCOUNTDISABLE' } // eventResponse
      /// data: { status: 'Error', data: 'Algo', message: 'ZOOMACCOUNTNOTEXISTS' } // eventResponse
      /// data: { status: 'Error', data: 'Algo', message: 'otro error genérico' } // eventResponse
    });
  } catch (error) {
    yield put({
      type: Types.SET_EVENT_INSCRIPTION_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del evento.'
    });
  }
}
